import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

/**
 * Renders children directly under document.body so `position: fixed` overlays
 * are not trapped by any ancestor that creates a containing block
 * (transform, backdrop-filter, will-change, contain, etc.).
 */
export default function Portal({ children }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (!mounted) return null;
  return createPortal(children, document.body);
}
